export default "__VITE_ASSET__CexAKrew__"